import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { EMPTY, catchError, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CUSTOMER_INTAKE_ENDPOINT } from './customer-intake.service';

/**
 * A 429 from any customer-intake request (lookup, save, submit) ends the sign-up visit: it replaces the page with
 * /too-many-requests, which clears the stores. The request completes without a value or an error, so the
 * callers' own error handling (form errors, the lookup's error state) doesn't run for it.
 */
export const signupThrottleInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(`${environment.apiUrl}${CUSTOMER_INTAKE_ENDPOINT}`)) return next(req);
  const router = inject(Router);

  return next(req).pipe(
    catchError((err: unknown) => {
      if (!(err instanceof HttpErrorResponse) || err.status !== 429) return throwError(() => err);
      // Replaces /signup in history, so Back returns to the landing page rather than the throttled form
      router.navigate(['/too-many-requests'], { replaceUrl: true });
      return EMPTY;
    }),
  );
};
